export default __webpack_public_path__ + "static/media/promo-banner-stable-coin-liquidity-mining.bfee3316.svg";